import { styled } from '@linaria/react';
import { fonts, layout, primitives, radius, semantic, size, space } from '../../theme/tokens';
import { visuallyHidden } from '../../utils/visuallyHidden';

export const Bar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${space['space-1200']};
  background: ${semantic.bg.canvas};

  & > button {
    left: 0;
  }
`;

export const TrailingAction = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
`;

export const ItineraryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  min-width: ${space['space-1600']};
  height: ${space['space-1200']};
  padding: 0 ${space['space-500']};
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: ${semantic.bg.surfaceSubtle};
  color: ${semantic.icon.primary};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: ${semantic.bg.surfaceDefault};
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;

export const ItineraryLabel = styled.span`
  ${visuallyHidden}

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
    font-family: ${fonts.body};
    font-size: ${fonts.size.base};
    font-weight: ${fonts.weight.medium};
    line-height: ${primitives.typography.lineHeight.normal};
    letter-spacing: ${primitives.typography.tracking.normal};
    white-space: nowrap;
    color: ${semantic.text.primary};
  }
`;
